module.exports = __webpack_public_path__ + "img/zm.d35f5ba6.svg";